"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = require("preact");

var SerasaConsumidorIcon = function SerasaConsumidorIcon(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color,
      className = _ref.className;
  return (0, _preact.h)(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", width: width, height: height, viewBox: "0 0 22 28", className: className },
    (0, _preact.h)(
      "g",
      { fill: color, "fill-rule": "nonzero" },
      (0, _preact.h)("path", { d: "M13.72 6.608h-3.192c-.952 0-1.68-.784-1.68-1.68V1.736c0-.952.784-1.68 1.68-1.68h3.192c.952 0 1.68.784 1.68 1.68v3.192c0 .896-.784 1.68-1.68 1.68M5.488 13.72H1.904C.84 13.72 0 12.824 0 11.76V8.176c0-1.064.84-1.904 1.904-1.904h3.584c1.064 0 1.904.84 1.904 1.904v3.584c0 1.064-.84 1.96-1.904 1.96M5.152 21.112H2.968a1.148 1.148 0 0 1-1.176-1.176v-2.184c0-.672.504-1.176 1.176-1.176h2.184c.672 0 1.176.504 1.176 1.176v2.184c0 .672-.504 1.176-1.176 1.176M10.976 28H8.4c-.784 0-1.4-.616-1.4-1.4v-2.576c0-.784.616-1.4 1.4-1.4h2.576c.784 0 1.4.616 1.4 1.4V26.6c0 .784-.616 1.4-1.4 1.4M20.44 7.896h-1.792a.981.981 0 0 1-.952-.952V5.152c0-.504.448-.952.952-.952h1.792c.504 0 .952.448.952.952v1.792a.944.944 0 0 1-.952.952M14.504 15.176c-.616-.336-1.288-.672-1.904-1.008a8.192 8.192 0 0 1-.728-.504c-.504-.504-.392-1.232.168-1.512a1.08 1.08 0 0 1 .56-.168c.56-.056 1.12.056 1.624.392.28.168.56.28.84.336.28.056.56-.056.728-.336.168-.224.168-.504.056-.784a1.322 1.322 0 0 0-.448-.504c-.728-.56-1.512-.784-2.408-.784-.672 0-1.288.168-1.848.448-1.232.672-1.68 2.016-1.176 3.304.28.616.728 1.064 1.288 1.4.504.28 1.064.56 1.568.784.448.224.84.448 1.232.84.448.448.504.952.224 1.344-.224.336-.504.448-.896.504-.728.112-1.344-.056-1.96-.448-.224-.112-.392-.28-.672-.336-.672-.224-1.232.224-1.12.896.056.28.224.504.448.672 1.12.952 3.136 1.232 4.536.56 1.456-.728 1.96-2.296 1.232-3.696-.28-.728-.784-1.12-1.344-1.4" })
    )
  );
};

SerasaConsumidorIcon.defaultProps = {
  width: 22,
  height: 28,
  color: '#ffffff'
};

exports.default = SerasaConsumidorIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/components/Icon/SerasaConsumidorIcon.js
// module id = 207
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38